import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import BenchmarkingQHPService from "@app/overviews/network-benchmarking-dashboard/benchmarkingQHPService";
import { QHPContractPrimaryFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/marketplace/filters/shared/QHPContractPrimaryFiltersPayload";
import { QHPNetwork } from "@app/overviews/network-benchmarking-dashboard/marketplace/filters/shared/QHPNetwork";

export interface QHPContractDetailsResult {
  contractDetails: QHPNetwork | undefined;
  isLoading: boolean;
}

export const QHP_CONTRACT_DETAILS_QUERY_KEY_PREFIX = "benchmarking-qhp-contract";

export const useQHPContractDetails = (contractPayload: QHPContractPrimaryFiltersPayload | null): QHPContractDetailsResult => {
  const benchmarkingQHPService = useMemo(() => new BenchmarkingQHPService(), []);

  const queryResult = useQuery<QHPNetwork>({
    enabled: !!contractPayload,
    queryFn: ({ signal }) => benchmarkingQHPService.getContractDetails(contractPayload, signal),
    queryKey: [QHP_CONTRACT_DETAILS_QUERY_KEY_PREFIX, JSON.stringify(contractPayload)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    contractDetails: queryResult.data,
    isLoading: queryResult.isFetching,
  };
}

export default useQHPContractDetails;
